import { Suspense, lazy } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import GTMManager from "../helpers/GTMManager";
import SamplePage from "./SamplePage";

const Home = lazy(() => import("./Home"));
const HousingLoans = lazy(() => import("./HousingLoans"));
const RequestCallBack = lazy(() => import("./RequestCallBack"));
const Social_Media = lazy(() => import("./socialmedia"));
const NonHousingLoans = lazy(() => import("./NonHousingLoans"));
const Calculators = lazy(() => import("./Calculators"));
const Contactus = lazy(() => import("./Contactus"));
const Faqs = lazy(() => import("./Faqs"));
const Investor = lazy(() => import("./Investor"));
const PublicDisclosure = lazy(() => import("./PublicDisclosure"));
const DebtDisclosure = lazy(() => import("./DebtDisclosure"));
const InvestorContact = lazy(() => import("./InvestorContact"));
const RegulatorNotice = lazy(() => import("./RegulatorNotice"));
const OtherNotice = lazy(() => import("./OtherNotice"));
const Careers = lazy(() => import("./Careers"));
const Productsdetail = lazy(() => import("./Productsdetail"));
const Loandetail = lazy(() => import("./Loandetail"));
const CusomEligibilityCalculator = lazy(() => import("./Customeligibility"));
const LeCusomEligibilityCalculator = lazy(() => import("./LeCustomeligibility"));
const LoanAgainstPropertyEligibility = lazy(() => import("./LoanAgainstPropertyEligibility"));
const PayEmiAmount = lazy(() => import("./PayEmiAmount"));
const ThankYouBehtarBroker = lazy(() => import("./ThankYouBehtarBroker"));
const HomeloanTaxbenefit = lazy(() => import("./HomeloanTaxbenefit"));
const Thankyou = lazy(() => import("./Thankyou"));
const SocialMediaThankyou = lazy(() => import("./SocialMediaThankyou"));
const ThanksCarrier = lazy(() => import("./ThanksCarrier"));
const ThanksConnector = lazy(() => import("./ThanksConnectors"));
const Enquiry = lazy(() => import("./Enquiry_new"));
const Enquiry_referals = lazy(() => import("./Enquiry_referals"));
const Search = lazy(() => import("./Search"));
const PoliciesCodes = lazy(() => import("./PoliciesCodes"));
const HomeLoanEMICalculator = lazy(() => import("./HomeLoanEMICalculator"));
const PrePaymentCalculator = lazy(() => import("./PrePaymentCalculator"));
const MortgateLoanEMICalculator = lazy(() => import("./MortgateLoanEMICalculator"));
const PmaySubsidy = lazy(() => import("./PmaySubsidy"));
const Blog = lazy(() => import("./Blog"));
const Blogdetails = lazy(() => import("./Blogdetails"));
const VideoMicrosite = lazy(() => import("./VideoMicrosite"));
const RentVersusBuy = lazy(() => import("./rentVersusBuy"));
const DIYInstaLoanForm = lazy(() => import("./DIYInstaLoanForm"));
const BranchLocator = lazy(() => import("./Branchlocator"));
const NewHomeLoan = lazy(() => import("./NewHomeLoan"));
const SelfConstruction = lazy(() => import("./SelfConstruction"));
const BalanceTransfer = lazy(() => import("./BalanceTransfer"));
const PlotPurchase = lazy(() => import("./PlotPurchase"));
const LapResidential = lazy(() => import("./LapResidential"));
const CommercialPurchase = lazy(() => import("./CommercialPurchase"));
const CareerForm = lazy(() => import("./CareerForm"));
const MyAccount = lazy(() => import("./Myaccount").then(m => ({ default: m.MyAccount })));
const RenovationOrExtension = lazy(() => import("./RenovationOrExtension"));
const NotFound = lazy(() => import("./404Page"));
const MixedUsedProperty = lazy(() => import("./MixedUsedProperty"));
const CommercialProperty = lazy(() => import("./CommercialProperty"));
const PrivacyPolicy = lazy(() => import("./PrivacyPolicy"));
const Sitemap = lazy(() => import("./Sitemap"));
const Non_Housing = lazy(() => import("./NonHousingEnquiry_new"));
const EnquiryThankYou = lazy(() => import("./EnquiryThankYou"));
const InstaPhonePeThankYou = lazy(() => import("./InstaPhonePeThankYou"));
const ConcentFormThankyou = lazy(() => import("./ConcentFormThankyou"));
const EnquiryReferThankYou = lazy(() => import("./EnquiryReferThankyou"));
const NonHousingThankyou = lazy(() => import("./NonHousingEnquiryThankyou"));
const InvestorRelations = lazy(() => import("./InvestorsRelations"));
const Job_details = lazy(() => import("./JobDetails"));
const Job_search = lazy(() => import("./JobSearch"));
const AuctionProperty = lazy(() => import("./AuctionProperty"));
const AuctionPropertyListing = lazy(() => import("./AuctionPropertyListing"));
const AuctionPropertyDetail = lazy(() => import("./AuctionPropertyDetail"));
const ThankyouInterest = lazy(() => import("./ThankYouInterest"));
const Nach_mendate = lazy(() => import("./Nach_mendate_form"));
const NachThankYou = lazy(() => import("./NachThankYou"));
const ThankYouPayEmi = lazy(() => import("./ThankYouPayEmi"));
const ConnectorOnboarding = lazy(() => import("./ConnectorOnboarding"));
const VendorOTPVerification = lazy(() => import("./VendorOTPVerification"));
const ConcentFormVerification = lazy(() => import("./ConcentForm"));
const HomeLoanEligibilityCalculator = lazy(() => import("./HomeLoanEligibilityCalculator"));
const PlotPurchaseHi = lazy(() => import("./PlotPurchaseHi"));
const NonHousingLoanHindi = lazy(() => import("./Non-HousingLoanHindi"));
const HomeLoanInterestRate = lazy(() => import("./HomeLoanInterestRate"));
const HomeLoanInterestRateHindi = lazy(() => import("./HomeLoanInterestRateHindi"));
const HomeLoanDelhi = lazy(() => import("./HomeLoanDelhi"));
const HomeLoanMumbai = lazy(() => import("./HomeLoanMumbai"));
const HomeLoanPune = lazy(() => import("./HomeLoanPune"));
const HomeLoanChennai = lazy(() => import("./HomeLoanChennai"));
const SpiceMoney = lazy(() => import("./SpiceMoney"));
const BehtarPartner = lazy(() => import("./BehtarPartner"));
const AprCalculator = lazy(() => import("./AprCalculator"));
const FlipkartLap = lazy(() => import("./FlipkartLap"));
const FlipkartNonHousingThankyou = lazy(() => import("./FlipkartLapThankyou"));
const FlipkartEnquiry = lazy(() => import("./FlipkartHomeLoan"));
const FlipkartEnquiryThankYou = lazy(() => import("./FlipkartThankYou"));
const AtsLoanLead = lazy(() => import("./AtsLoanLead"));
const Job_apply = lazy(() => import("./job_apply"));

const Aboutus = lazy(() => import("./Aboutus_uat"));
const ConstructionFinance = lazy(() => import("./ConstructionFinance"));
const LeLoanOfferVendor = lazy(() => import("./LoanOffer-vendor"));

const Main = () => {
  const { pathname } = useLocation();

  return (
    <main>
      <GTMManager />
      <Suspense fallback={<div className="page-loader"></div>}>
      <Switch>
        {/* <Redirect from="/" to={`${window.location.protocol}//www.${window.location.host}${pathname}`} /> */}
        {/* <Redirect from={window.location.href} to="/housing-loans/home-loan-rate-of-interest" /> */}
        <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
        <Route
          exact
          activeClassName="active"
          path="/:lang(hi|gu|mr)?"
          component={Home}
        />
        <Redirect
          exact
          from="/loans/housing-loans/new-home-loan"
          to="/housing-loans/home-loan-without-income-proof"
        />
        <Redirect
          exact
          from="/housing-loans/home-loan-rate-of-interest"
          to="/housing-loans/home-loan-without-income-proof"
        />
        <Route
          path="/housing-loans/home-loan-without-income-proof"
          component={NewHomeLoan}
        />
        <Redirect
          exact
          from="/loans/housing-loan/balance-transfer"
          to="/housing-loans/home-loan-balance-transfer"
        />
        <Route
          exact
          path="/housing-loans/home-loan-balance-transfer"
          component={BalanceTransfer}
        />
        <Redirect
          exact
          from="/loans/housing-loan/self-construction"
          to="/housing-loans/home-construction-loan"
        />
        <Route
          path="/housing-loans/home-construction-loan"
          component={SelfConstruction}
        />
        <Redirect
          exact
          from="/loans/housing-loan/plot-purchase"
          to="/housing-loans/plot-loan"
        />
        <Route
          path="/housing-loans/plot-loan"
          component={PlotPurchase}
          sensitive
        />

        <Route
          path="/hi/housing-loans/plot-loan"
          component={PlotPurchaseHi}
          sensitive
        />
        <Redirect exact from="/non-housing-loans" to="/loan-against-property" />
        <Route
          exact
          path="/loan-against-property"
          component={NonHousingLoans}
          sensitive
        />
        <Route
          exact
          path="/hi/loan-against-property"
          component={NonHousingLoanHindi}
          sensitive
        />
        <Route
          exact
          path="/home-loan-interest-rate"
          component={HomeLoanInterestRate}
          sensitive
        />
        <Route
          exact
          path="/hi/home-loan-interest-rate"
          component={HomeLoanInterestRateHindi}
          sensitive
        />

        <Route
          path="/housing-loans/home-renovation-loan"
          component={RenovationOrExtension}
          sensitive
        />
        <Route
          path="/loan-against-property-eligibility"
          component={LoanAgainstPropertyEligibility}
          sensitive
        />
        <Route exact path="/housing-loans" component={HousingLoans} sensitive />
        <Route
          exact
          path="/request-a-call-back"
          component={RequestCallBack}
          sensitive
        />
        <Redirect
          exact
          from="/loans/non-housing-loan/lap-residential"
          to="/non-housing-loans/loan-against-property-without-income-proof"
        />
        <Redirect
          exact
          from="/non-housing-loans/lap-loan"
          to="/non-housing-loans/loan-against-property-without-income-proof"
        />
        <Route
          path="/non-housing-loans/loan-against-property-without-income-proof"
          component={LapResidential}
        />
        <Route
          path="/non-housing-loans/loan-against-commercial-property"
          component={CommercialProperty}
        />
        <Redirect
          exact
          from="/loans/non-housing-loan/commercial-purchase"
          to="/non-housing-loans/commercial-property-loan"
        />
        <Route
          path="/non-housing-loans/commercial-property-loan"
          component={CommercialPurchase}
        />
        <Route
          path="/non-housing-loans/mixed-used-property-loan"
          component={MixedUsedProperty}
        />

        <Route
          path="/calculators/custom-eligibility-calculator/:type"
          exact
          component={CusomEligibilityCalculator}
          sensitive
        />
        <Route
          path="/instant-loan-approval/:type"
          exact
          // component={LeCusomEligibilityCalculator}
          component={DIYInstaLoanForm}
          sensitive
        />
        <Route
          path="/instant-loan-approval-contact-center/:type"
          exact
          component={LeLoanOfferVendor}
          sensitive
        />
        {/* <Route
          path="/instant-loan-verify-otp/:mobile_number"
          component={VendorOTPVerification}
        /> */}
        <Route
          path="/vendor-verification/:mobile_number"
          component={VendorOTPVerification}
        />
        <Route path="/tnc-concent" component={ConcentFormVerification} />
        <Route
          path="/concent-form-verify-otp/thank-you"
          component={ConcentFormThankyou}
        />
        <Route path="/spice-money-tnc-concent" component={SpiceMoney} />
        <Route
          path="/instant-loan-phonepe-verify-otp/thank-you"
          component={InstaPhonePeThankYou}
        />
        <Route
          path="/calculators/lead-enrichment-calculator/:type"
          exact
          component={CusomEligibilityCalculator}
          sensitive
        />
        <Route
          exact
          path="/calculators/mortgage-loan-emi-calculator"
          component={MortgateLoanEMICalculator}
          sensitive
        />
        <Route
          path="/calculators/pmay-subsidy-calculator"
          exact
          component={PmaySubsidy}
          sensitive
        />
        <Route
          exact
          path="/calculators/home-loan-emi-calculator"
          component={HomeLoanEMICalculator}
          sensitive
        />
        <Route
          exact
          path="/:lang(hi|gu|mr)/calculators/home-loan-emi-calculator"
          component={HomeLoanEMICalculator}
          sensitive
        />
        <Route
          exact
          path="/calculators/home-loan-eligibility-calculator"
          component={HomeLoanEligibilityCalculator}
          sensitive
        />
        <Route
          exact
          path="/calculators/apr-calculator"
          component={AprCalculator}
          sensitive
        />
        <Route path="/calculators" exact component={Calculators} sensitive />
        <Redirect exact from="/aboutus" to="/about-us" sensitive />
        <Route path="/about-us" component={Aboutus} />
        <Route path="/nach-mendate" component={Nach_mendate} />
        <Route path="/pay-emi" component={PayEmiAmount} />
        <Redirect exact from="/contactus" to="/contact-us" />
        <Route path="/contact-us" component={Contactus} sensitive />
        <Redirect exact from="/faq" to="/faqs" sensitive />
        <Route path="/faqs" component={Faqs} sensitive />
        <Route path="/sitemap" component={Sitemap} sensitive />
        <Route
          path="/connector-onboarding"
          component={ConnectorOnboarding}
          sensitive
        />
        <Redirect
          exact
          from="/financial-performance"
          to="/investor-relations/financial-performance"
        />
        <Redirect
          exact
          from="/investor-relations"
          to="/investor-relations/financial-performance"
        />
        {/* <Route exact path="" component={Investor} /> */}
        <Route
          exact
          path="/investor-relations/financial-performance"
          component={InvestorRelations}
        />
        <Redirect exact from="/investrelation" to="/policies-and-codes" />
        <Route path="/policies-and-codes" component={PoliciesCodes} />
        <Redirect
          exact
          from="/public-disclosure-on-liquidity-risk-management"
          to="/investor-relations/public-disclosure-on-liquidity-risk-management"
        />
        <Route
          path="/investor-relations/public-disclosure-on-liquidity-risk-management"
          component={PublicDisclosure}
          sensitive
        />
        <Redirect
          exact
          from="/debt-disclosures"
          to="/investor-relations/debt-disclosures"
        />
        <Route
          path="/investor-relations/debt-disclosures"
          component={DebtDisclosure}
          sensitive
        />
        <Redirect
          exact
          from="/investor-contact"
          to="/investor-relations/investor-contact"
        />
        <Route
          path="/investor-relations/investor-contact"
          component={InvestorContact}
          sensitive
        />
        <Redirect
          exact
          from="/regulator-notice"
          to="/investor-relations/regulator-notice"
        />
        <Route
          path="/investor-relations/regulator-notice"
          component={RegulatorNotice}
          sensitive
        />
        <Redirect
          exact
          from="/other-notice"
          to="/investor-relations/other-notice"
        />
        <Route
          path="/investor-relations/other-notice"
          component={OtherNotice}
        />
        <Route
          path="/careers"
          component={(props) => (
            <Careers
              {...props}
            />
          )}
        />

        <Route
          exact
          path="/home-loan-in-delhi"
          component={HomeLoanDelhi}
          sensitive
        />
        <Route
          exact
          path="/home-loan-in-mumbai"
          component={HomeLoanMumbai}
          sensitive
        />
        <Route
          exact
          path="/home-loan-in-pune"
          component={HomeLoanPune}
          sensitive
        />
        <Route
          exact
          path="/home-loan-in-chennai"
          component={HomeLoanChennai}
          sensitive
        />

        <Route path="/detail/:alias" component={Productsdetail} />
        <Route path="/Loandetail" component={Loandetail} />
        <Route path="/thank-you" component={Thankyou} />
        <Route path="/thank-you-home-verse" component={ThankYouBehtarBroker} />
        <Route path="/thank-you-interest" component={ThankyouInterest} />
        <Route path="/thank-you-career" component={ThanksCarrier} />
        <Route path="/thank-you-connectors" component={ThanksConnector} />
        <Route path="/HomeloanTaxbenefit" component={HomeloanTaxbenefit} />
        <Route
          path="/landing/phonepehomeloan/thank-you"
          component={EnquiryThankYou}
        />
        <Route
          path="/landing/flipkarthomeloan/thank-you"
          component={FlipkartEnquiryThankYou}
        />
        <Route
          exact
          path="/landing/enquiry-referals/thank-you"
          component={EnquiryReferThankYou}
        />
        <Route exact path="/nach_mendate/thank-you" component={NachThankYou} />
        <Route path="/landing/phonepehomeloan" component={Enquiry} />
        <Route path="/landing/applynow" component={AtsLoanLead} />


        <Route path="/landing/flipkarthomeloan" component={FlipkartEnquiry} />
        <Route
          path="/landing/apply-now/thank-you"
          component={SocialMediaThankyou}
        />
        <Route
          path="/landing/phonepelap/thank-you"
          component={NonHousingThankyou}
        />
        <Route path="/landing/flipkartlap/thank-you" component={FlipkartNonHousingThankyou} />
        <Route path="/landing/phonepelap" component={Non_Housing} />
        <Route path="/landing/flipkartlap" component={FlipkartLap} />
        {/* <Route path="/landing/ats-loan" component={AtsLoanLead} /> */}
        <Route path="/landing/enquiry-referals" component={Enquiry_referals} />
        <Route path="/Search" component={Search} />
        <Route
          path="/calculators/home-loan-prepayment-calculator"
          component={PrePaymentCalculator}
        />
        <Route
          exact
          path="/blog/:category_alias/:alias"
          component={Blogdetails}
        />
        <Route exact path="/blog/:category_alias" component={Blog} />
        <Route exact path="/blog" component={Blog} />
        <Route
          path="/hero-housing-video/:alias/:paramValue"
          exact
          component={VideoMicrosite}
          sensitive
        />
        {/* <Suspense fallback={<div>Loading...</div>}>
        <Blog/>
      </Suspense> */}
        <Route path="/calculators/rent-versus-buy" component={RentVersusBuy} />
        {/* <Route path="/RentVersusBuyOld" component={RentVersusBuyOld} /> */}
        {/* <Route path="/renttest" component={RentVersusBuyTest} /> */}
        <Route path="/locate-us" component={BranchLocator} />
        <Route path="/privacy-policy" component={PrivacyPolicy} sensitive />
        <Route path="/pre-approved-top-up-tnc" component={SamplePage} sensitive />
        <Route path="/CareerForm/:job_id" component={CareerForm} />
        <Route path="/job_details" component={Job_details} />
        {/* <Route path="/job_apply" component={job_apply} />
        */}
        <Route path="/job_apply"
        component={(props) => (
          <Suspense fallback={<div/>}>
            <Job_apply {...props} />
          </Suspense>
        )}
        />
        <Route path="/job_search" component={Job_search} />
        <Route path="/MyAccount" component={MyAccount} />
        <Route path="/not-found" component={NotFound} />
        <Route path="/auction-property" component={AuctionProperty} />
        <Route path="/thank-you-pay-emi/:orderId" component={ThankYouPayEmi} />
        <Route
          path="/auction-property-listing"
          component={AuctionPropertyListing}
        />
        <Route
          path="/auction-property-detail"
          component={AuctionPropertyDetail}
        />
          <Route
          path="/construction-finance"
          component={ConstructionFinance}
        />
        <Route path="/homeverse" component={BehtarPartner} />
        {/* Testing route */}
        <Route
          path="/instant-loan-approval-2/:type"
          exact
          // component={DIYInstaLoanForm}
          component={LeCusomEligibilityCalculator}
          sensitive
        />
        <Redirect from="/" to="/not-found" />
      </Switch>
    </Suspense>
    </main >
  );
};

export default Main;
